import Footer from "../ones/Footer";
import ProjectsContent from "../ones/ProjectsContent";

export default function ProjectsLanding() {
  return (
    <>
      <ProjectsContent />
      <Footer />
    </>
  );
}
